import {Component, Input} from '@angular/core';
import {CoreComponent} from "../../../../core/component/core-component/core.component";
import {ActivatedRoute, Router} from "@angular/router";
import {ScheduleTypeDto} from "../../../../core/interfaces/core.types";

@Component({
  selector: 'schedule-appointment-call-us',
  templateUrl: 'schedule-appointment-call-us.component.html',
})
export class ScheduleAppointmentCallUsComponent extends CoreComponent {

  phoneUrl: string | undefined;
  phone: string | undefined;

  constructor(protected router: Router, protected activatedRoute: ActivatedRoute) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.initComponent();
  }

  initComponent() {

    const contact = this.activatedRoute.snapshot.queryParams['contact'];
    this.phone = contact;

    this.phoneUrl = `tel:${contact}`;

    if (contact) {
      this.refreshComponent()
    }
  }

  refreshComponent() {
    this.initialized = true;
  }


}
